/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4CrossDiagIcon20Light = forwardRef('ArrowDim4CrossDiagIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.5 2.5A.5.5 0 0 1 13 2h3.5A1.5 1.5 0 0 1 18 3.5V7a.5.5 0 0 1-1 0V3.707L10.707 10 17 16.293V13a.5.5 0 0 1 1 0v3.5a1.5 1.5 0 0 1-1.5 1.5H13a.5.5 0 0 1 0-1h3.293L10 10.707 3.707 17H7a.5.5 0 0 1 0 1H3.5A1.5 1.5 0 0 1 2 16.5V13a.5.5 0 0 1 1 0v3.293L9.293 10 3 3.707V7a.5.5 0 0 1-1 0V3.5A1.5 1.5 0 0 1 3.5 2H7a.5.5 0 0 1 0 1H3.707L10 9.293 16.293 3H13a.5.5 0 0 1-.5-.5Z" })));
});
